/* global axios */

import {
  buildTrackingEnvelope,
  snakeCaseKeys,
} from 'dashboard/helper/AnalyticsHelper/utils/trackingEnvelope';

const currentUtmProperties = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  return Array.from(params.entries()).reduce((acc, [key, value]) => {
    if (key.startsWith('utm_') && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

class AnalyticsEventsAPI {
  constructor() {
    this.endpoint = '/api/v2/analytics_events';
  }

  create(event = {}) {
    const eventName = event.name || event.event || 'analytics_event';
    const envelope = buildTrackingEnvelope(eventName, event.properties || {});
    const rootEvent = snakeCaseKeys(event);
    const payload = {
      ...rootEvent,
      name: eventName,
      session_id: event.session_id || event.sessionId || envelope.sessionId,
      device_id: event.device_id || event.deviceId,
      properties: snakeCaseKeys({
        ...currentUtmProperties(),
        ...envelope,
      }),
    };

    return axios.post(this.endpoint, { event: payload });
  }
}

export default new AnalyticsEventsAPI();
